import find from 'lodash/find'

export type ElaLevelingProgramT =
  'development_reading_assessment' | 'fountas_and_pinnell' | 'freckle' | 'star_scaled_score'

type ElaLevelingProgramsT = {
  Dra: ElaLevelingProgramT
  FAndP: ElaLevelingProgramT
  FreckleTextLevel: ElaLevelingProgramT
  StarScaledScore: ElaLevelingProgramT
  all: () => Array<ElaLevelingProgramT>
  parse: (s: string) => ElaLevelingProgramT | undefined | null
}

export const ElaLevelingPrograms: ElaLevelingProgramsT = {
  Dra: 'development_reading_assessment',
  FAndP: 'fountas_and_pinnell',
  FreckleTextLevel: 'freckle',
  StarScaledScore: 'star_scaled_score',
  all: function (): Array<ElaLevelingProgramT> {
    return [
      ElaLevelingPrograms.Dra,
      ElaLevelingPrograms.FAndP,
      ElaLevelingPrograms.StarScaledScore,
      ElaLevelingPrograms.FreckleTextLevel
    ]
  },
  parse: function (s: string): ElaLevelingProgramT | undefined | null {
    return find(ElaLevelingPrograms.all(), program => s === program) || null
  }
}
